import React from "react";
import { Link } from "react-router-dom";
import { Waveform } from "@phosphor-icons/react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t rule bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Waveform size={20} weight="duotone"/>
              <span className="font-serif text-xl">Ekkol</span>
            </div>
            <div className="eyebrow mb-2 text-[color:var(--ink-muted)]">[ EH · KOL ]</div>
            <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed max-w-xs">
              Voice-first memorization. Speak it into memory.
            </p>
          </div>

          <div>
            <div className="eyebrow mb-4">Product</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="link-underline">Home</Link></li>
              <li><Link to="/pricing" className="link-underline" data-testid="footer-pricing">Pricing</Link></li>
              <li><Link to="/help" className="link-underline" data-testid="footer-help">Help center</Link></li>
              <li><Link to="/login" className="link-underline">Sign in</Link></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:hello@ekkol.app" className="link-underline">Contact</a></li>
              <li><a href="mailto:sales@ekkol.app" className="link-underline">For schools</a></li>
              <li><a href="mailto:press@ekkol.app" className="link-underline">Press</a></li>
              <li><a href="mailto:hello@ekkol.app?subject=Partnership" className="link-underline">Partnerships</a></li>
            </ul>
          </div>

          <div>
            <div className="eyebrow mb-4">Legal</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/legal/terms" className="link-underline" data-testid="footer-terms">Terms of service</Link></li>
              <li><Link to="/legal/privacy" className="link-underline" data-testid="footer-privacy">Privacy policy</Link></li>
              <li><Link to="/legal/disclaimer" className="link-underline" data-testid="footer-disclaimer">Disclaimer &amp; AUP</Link></li>
              <li><a href="mailto:privacy@ekkol.app" className="link-underline">Privacy questions</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t rule pt-6 flex flex-wrap items-center justify-between gap-4 text-xs text-[color:var(--ink-muted)] font-mono">
          <div>© {year} Ekkol · Greensboro, NC · Made with care</div>
          <div className="flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[color:var(--success)]"/>
            All systems operational
          </div>
        </div>
      </div>
    </footer>
  );
}
